export default __webpack_public_path__ + "static/media/D_wdt_c_cap_1.ce85b6ed.mp3";